// Materials that light up at night.

export const nightMats = []; // [material, night emissive intensity] pairs that light up after dark
